module.exports = __webpack_public_path__ + "static/media/csaSnapshot.11e3cb43.svg";